export const DAY_SCHEDULE = [
    { day: 0, name: "Sunday", open: null, close: null, display: "Closed" },
    { day: 1, name: "Monday", open: 8, close: 18.5, display: "8:00 AM – 6:30 PM" },
    { day: 2, name: "Tuesday", open: 8, close: 18.5, display: "8:00 AM – 6:30 PM" },
    { day: 3, name: "Wednesday", open: 8, close: 18.5, display: "8:00 AM – 6:30 PM" },
    { day: 4, name: "Thursday", open: 8, close: 18.5, display: "8:00 AM – 6:30 PM" },
    { day: 5, name: "Friday", open: 8, close: 16, display: "8:00 AM – 4:00 PM" },
    { day: 6, name: "Saturday", open: 9, close: 13, display: "9:00 AM – 1:00 PM" },
];

export const fmtHour = (h) => {
    const hour = Math.floor(h);
    const mins = h % 1 === 0.5 ? "30" : "00";
    const ampm = hour >= 12 ? "PM" : "AM";
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${h12}:${mins} ${ampm}`;
};

export const getStatus = (now = new Date()) => {
    const day = now.getDay();
    const t = now.getHours() + now.getMinutes() / 60;
    const today = DAY_SCHEDULE[day];
    if (today.open !== null && t >= today.open && t < today.close) {
        return { open: true, label: `Open now · until ${fmtHour(today.close)}` };
    }
    for (let i = 0; i < 7; i++) {
        const d = DAY_SCHEDULE[(day + i) % 7];
        if (d.open === null) continue;
        if (i === 0 && t < d.open)
            return { open: false, label: `Closed · opens today ${fmtHour(d.open)}` };
        if (i === 0) continue;
        return {
            open: false,
            label: `Closed · opens ${i === 1 ? "tomorrow" : d.name} ${fmtHour(d.open)}`,
        };
    }
    return { open: false, label: "Closed" };
};
